export enum Role {
  admin,
  normal,
  unauthorized,
}


// WEBPACK FOOTER //
// ./src/models/roles.ts